// 此函数主要用于在字符串中查找和替换特殊字符，用于处理可能会引发正则表达式错误的字符串
export const searchValueEscape = (searchValue: string) => {
  const specialCharacter = [
    '\\',
    '$',
    '(',
    ')',
    '*',
    '+',
    '.',
    '[',
    '?',
    '^',
    '{',
    '|',
  ];
  specialCharacter.forEach((str) => {
    const reg = new RegExp(`\\${str}`, 'gim');
    searchValue = searchValue?.replace?.(reg, `\\${str}`);
  });
  return searchValue;
};

// 搜索高亮
export const highlightText = (text: string, searchValue: string) => {
  const reg = new RegExp(`${searchValueEscape(searchValue)}`, 'gi');
  const setText = (text: string) => `<span style='color: #006EFF'>${text}</span>`;
  return text?.replace?.(reg, (matchText: string) => setText(matchText));
};
